// components/DropdownOptions.tsx
import React from "react";
import { DropdownOption } from "./types";
// import { DropdownOption } from "../types/dropdown";

interface DropdownOptionsProps {
  options: DropdownOption[];
  isSelected: (value: string) => boolean;
  highlightedIndex: number;
  onOptionSelect: (value: string) => void;
  onOptionHover: (index: number) => void;
  multiSelect: boolean;
  maxHeight: string;
}

export const DropdownOptions: React.FC<DropdownOptionsProps> = ({
  options,
  isSelected,
  highlightedIndex,
  onOptionSelect,
  onOptionHover,
  multiSelect,
  maxHeight,
}) => {
  if (options.length === 0) {
    return (
      <div className="px-4 py-2 text-sm text-gray-500 text-center">
        No options found
      </div>
    );
  }

  return (
    <div className="overflow-y-auto" style={{ maxHeight }}>
      {options.map((option, index) => (
        <div
          key={option.value}
          onClick={() => !option.disabled && onOptionSelect(option.value)}
          onMouseEnter={() => onOptionHover(index)}
          className={`
            px-4 py-1 text-sm cursor-pointer transition-colors duration-150
            ${
              option.disabled
                ? "text-gray-400 cursor-not-allowed bg-gray-50"
                : "hover:bg-blue-50"
            }
            ${
              isSelected(option.value)
                ? "bg-blue-50 text-blue-700 font-medium"
                : "text-gray-700"
            }
            ${
              highlightedIndex === index && !option.disabled
                ? "bg-blue-100"
                : ""
            }
          `}
        >
          <div className="flex items-center">
            {multiSelect && (
              <div className="mr-2">
                <input
                  type="checkbox"
                  checked={isSelected(option.value)}
                  onChange={() => {}}
                  disabled={option.disabled}
                  className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500"
                />
              </div>
            )}
            <span className={option.disabled ? "opacity-50" : "pb-1"}>
              {option.label}
            </span>
          </div>
        </div>
      ))}
    </div>
  );
};
